import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import PermWrapper from '@/components/PermWrapper';
import ColTip from '@/components/Tip';
import { toText } from '..';
import Modal from './Modal';

function PersistencePolicy({ data, commonProps }) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Descriptions
        bordered
        title='持久化策略'
        actions={
          <PermWrapper resource='pulsar:topic:list:configUpdate'>
            <Button onClick={() => setVisible(true)} theme='default' variant='outline' size='small'>
              修改
            </Button>
          </PermWrapper>
        }
      >
        <Descriptions.Item
          label={
            <ColTip
              content={
                <>
                  <strong>Ensemble</strong>
                  <li>1、设置副本写入的Bookie个数。</li>
                  <li>2、Ensemble必须大于或者等于副本个数。</li>
                  <li>3、建议Ensemble和副本个数一致。</li>
                  <li>4、为了保证可用性，集群的Bookie个数必须大于Ensemble。</li>
                </>
              }
            >
              Ensemble
            </ColTip>
          }
          value={toText(data.ensemble)}
        />
        <Descriptions.Item label='副本个数' value={toText(data.writeQuorum)} />
        <Descriptions.Item label='确认个数' value={toText(data.ackQuorum)} />
      </Descriptions>
      <Modal
        visible={visible}
        commonProps={commonProps}
        detail={data}
        handleClose={() => setVisible(false)}
      />
    </>
  );
}

export default connect((state) => ({
  data: state.topic.proPolices,
}))(PersistencePolicy);
